import { Reveal } from "../components/Reveal";
import { PILLARS } from "../data/content";

export default function PillarsSection() {
  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36" data-testid="pillars-section">
      <div className="grid md:grid-cols-12 gap-x-10 gap-y-12">
        <div className="md:col-span-4">
          <Reveal>
            <h2 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.98]">
              Why a Quexify right hand is different.
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-8 border-t border-black/10">
          {PILLARS.map((p, i) => (
            <Reveal key={p.k} delay={i * 0.05}>
              <div className="grid sm:grid-cols-12 gap-2 sm:gap-8 items-baseline py-8 md:py-9 border-b border-black/10" data-testid={`pillar-${i}`}>
                <div className="sm:col-span-4 flex items-baseline gap-3">
                  <span className="font-display text-sm text-neutral-400 tabular-nums">{p.k}</span>
                  <h3 className="font-display text-xl md:text-2xl tracking-tight font-medium">{p.title}</h3>
                </div>
                <p className="sm:col-span-8 text-neutral-500 leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
